import { useCallback } from 'react';

import { useFollowings } from 'Shared/FollowUser/hooks/useFollowings';

import { useToggleFollow } from './useToggleFollow';
import { USER_TYPE } from './utils';

type OptionsT = {
  userId: string;
  isAuthor: boolean;
};

type UseToggleFollowUserT = (
  userType?: USER_TYPE.User | USER_TYPE.WallStreetBreakfast,
) => {
  follow: (arg1: OptionsT) => Promise<void>;
  unfollow: (arg1: OptionsT) => Promise<void>;
  toggleFollow: (
    arg1: OptionsT & {
      isFollowing: boolean;
    },
  ) => Promise<void>;
};

export const useToggleFollowUser: UseToggleFollowUserT = (
  userType = USER_TYPE.User,
) => {
  const { addFollowings, removeFollowings } = useFollowings();

  const { follow: followProp, unfollow: unfollowProp } =
    useToggleFollow(userType);

  const follow = useCallback(
    // @ts-expect-error ImplicitAny
    async ({ userId, isAuthor }) => {
      await followProp({
        userId,
        isAuthor,
      });

      addFollowings(userId);
    },
    [addFollowings, followProp],
  );

  const unfollow = useCallback(
    // @ts-expect-error ImplicitAny
    async ({ userId, isAuthor }) => {
      await unfollowProp({
        userId,
        isAuthor,
      });

      removeFollowings(userId);
    },
    [removeFollowings, unfollowProp],
  );

  const toggleFollow = useCallback(
    // @ts-expect-error ImplicitAny
    async ({ userId, isAuthor, isFollowing }) => {
      await (isFollowing
        ? unfollow({
            userId,
            isAuthor,
          })
        : follow({
            userId,
            isAuthor,
          }));
    },
    [follow, unfollow],
  );

  return {
    follow,
    unfollow,
    toggleFollow,
  };
};
